import { ApplicationAttachment } from '../applicationAttachment';

export class ValidationError extends Error {
  constructor(message = 'Please fill out required fields before submitting') {
    super(message);
    this.name = 'ValidationError';
  }
}

export class DocumentUploadValidationError extends ValidationError {
  attachment?: ApplicationAttachment;

  constructor(message = 'Please fill out required fields before submitting', attachment?: ApplicationAttachment) {
    super(message);
    this.name = 'DocumentUploadValidationError';
    this.attachment = attachment;
  }
}
